import { Padrao } from '../generic/padrao';
import { AutoRegisterClass } from 'src/app/services/generics/classRegistry';

@AutoRegisterClass()
export class Aerodromo extends Padrao {

    override idTab = 288;

    cod: string;
    nome: string;
    codOaci: string;
    codCiad: string;
    localidade: string;
    cidade: string;
    uf: string;
    situacao: string;
}
